import React from 'react';
import { PAGE_TITLE_BASE, PAGE_TITLE_ITEM} from '../../assets/const';
import topLayerImg from '../../assets/images/mainmenu_top_layer.gif';
import middleLayerImg from '../../assets/images/mainmenu_mid_layer.gif';
import sublinkImg from '../../assets/images/mainmenu_sublink.gif';

const ReportGuide = (props) =>{
    if(props.pageTitle ===　PAGE_TITLE_BASE){
        return(
            <p>
                <img alt="*" src={topLayerImg} />拠点⇒
                <img alt="*" src={middleLayerImg} />機器⇒
                <img alt="->" src={sublinkImg} />項目
            </p>
        )
    }else{
        return(
            <p>
                <img alt="*" src={topLayerImg} />項目⇒
                <img alt="*" src={middleLayerImg} />拠点⇒
                <img alt="->" src={sublinkImg} />機器
            </p>
        )
    }
}

export default ReportGuide;